const Download = (props) => (
	<svg
		id="ikony"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 22 22"
		{...props}
	>
		<g>
			<polygon
				points="20 15.98 20 20 2 20 2 15.98 1 15.98 1 21 1.38 21 2 21 21 21 21 20.96 21 20 21 15.98 20 15.98"
			/>
			<polygon
				points="11 16 16 10 12.5 10 12.5 1 9.5 1 9.5 10 6 10 11 16"
			/>
		</g>
	</svg>
);
export default Download;
